import React, { Suspense } from "react";
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import './index.scss';
import './portal.css';
import 'antd/dist/antd.css';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

